//# sourceMappingURL=dom.mjs.map
/// <reference types="./dom.d.mts" />
import * as $form_data from "../../gleam_fetch/gleam/fetch/form_data.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";
import {
  createPortal as create_portal,
  preconnect,
  prefetchDNS as prefetch_dns,
  preinit,
  preinitModule as preinit_module,
  preload,
  preloadModule as preload_module,
  useFormStatus as use_form_status,
} from "./dom.ffi.mjs";
import { flushSync as flush_sync } from "react-dom";

export {
  create_portal,
  flush_sync,
  preconnect,
  prefetch_dns,
  preinit,
  preinit_module,
  preload,
  preload_module,
  use_form_status,
};

export class InvalidRoot extends $CustomType {
  constructor(root) {
    super();
    this.root = root;
  }
}
export const Error$InvalidRoot = (root) => new InvalidRoot(root);
export const Error$isInvalidRoot = (value) => value instanceof InvalidRoot;
export const Error$InvalidRoot$root = (value) => value.root;
export const Error$InvalidRoot$0 = (value) => value.root;

export class Status extends $CustomType {
  constructor(pending, data, method, action) {
    super();
    this.pending = pending;
    this.data = data;
    this.method = method;
    this.action = action;
  }
}
export const Status$Status = (pending, data, method, action) =>
  new Status(pending, data, method, action);
export const Status$isStatus = (value) => value instanceof Status;
export const Status$Status$pending = (value) => value.pending;
export const Status$Status$0 = (value) => value.pending;
export const Status$Status$data = (value) => value.data;
export const Status$Status$1 = (value) => value.data;
export const Status$Status$method = (value) => value.method;
export const Status$Status$2 = (value) => value.method;
export const Status$Status$action = (value) => value.action;
export const Status$Status$3 = (value) => value.action;

export class AsScript extends $CustomType {}
export const As$AsScript = () => new AsScript();
export const As$isAsScript = (value) => value instanceof AsScript;

export class AsStyle extends $CustomType {}
export const As$AsStyle = () => new AsStyle();
export const As$isAsStyle = (value) => value instanceof AsStyle;

export class Anonymous extends $CustomType {}
export const CrossOrigin$Anonymous = () => new Anonymous();
export const CrossOrigin$isAnonymous = (value) => value instanceof Anonymous;

export class UseCredentials extends $CustomType {}
export const CrossOrigin$UseCredentials = () => new UseCredentials();
export const CrossOrigin$isUseCredentials = (value) =>
  value instanceof UseCredentials;

export class Auto extends $CustomType {}
export const FetchPriority$Auto = () => new Auto();
export const FetchPriority$isAuto = (value) => value instanceof Auto;

export class Low extends $CustomType {}
export const FetchPriority$Low = () => new Low();
export const FetchPriority$isLow = (value) => value instanceof Low;

export class High extends $CustomType {}
export const FetchPriority$High = () => new High();
export const FetchPriority$isHigh = (value) => value instanceof High;

export class NoReferrerWhenDowngrade extends $CustomType {}
export const ReferrerPolicy$NoReferrerWhenDowngrade = () =>
  new NoReferrerWhenDowngrade();
export const ReferrerPolicy$isNoReferrerWhenDowngrade = (value) =>
  value instanceof NoReferrerWhenDowngrade;

export class NoReferrer extends $CustomType {}
export const ReferrerPolicy$NoReferrer = () => new NoReferrer();
export const ReferrerPolicy$isNoReferrer = (value) =>
  value instanceof NoReferrer;

export class Origin extends $CustomType {}
export const ReferrerPolicy$Origin = () => new Origin();
export const ReferrerPolicy$isOrigin = (value) => value instanceof Origin;

export class OriginWhenCrossOrigin extends $CustomType {}
export const ReferrerPolicy$OriginWhenCrossOrigin = () =>
  new OriginWhenCrossOrigin();
export const ReferrerPolicy$isOriginWhenCrossOrigin = (value) =>
  value instanceof OriginWhenCrossOrigin;

export class UnsafeUrl extends $CustomType {}
export const ReferrerPolicy$UnsafeUrl = () => new UnsafeUrl();
export const ReferrerPolicy$isUnsafeUrl = (value) => value instanceof UnsafeUrl;

export class Audio extends $CustomType {}
export const Resource$Audio = () => new Audio();
export const Resource$isAudio = (value) => value instanceof Audio;

export class Document extends $CustomType {}
export const Resource$Document = () => new Document();
export const Resource$isDocument = (value) => value instanceof Document;

export class Embed extends $CustomType {}
export const Resource$Embed = () => new Embed();
export const Resource$isEmbed = (value) => value instanceof Embed;

export class Fetch extends $CustomType {}
export const Resource$Fetch = () => new Fetch();
export const Resource$isFetch = (value) => value instanceof Fetch;

export class Font extends $CustomType {}
export const Resource$Font = () => new Font();
export const Resource$isFont = (value) => value instanceof Font;

export class Image extends $CustomType {}
export const Resource$Image = () => new Image();
export const Resource$isImage = (value) => value instanceof Image;

export class Object extends $CustomType {}
export const Resource$Object = () => new Object();
export const Resource$isObject = (value) => value instanceof Object;

export class Script extends $CustomType {}
export const Resource$Script = () => new Script();
export const Resource$isScript = (value) => value instanceof Script;

export class Style extends $CustomType {}
export const Resource$Style = () => new Style();
export const Resource$isStyle = (value) => value instanceof Style;

export class Track extends $CustomType {}
export const Resource$Track = () => new Track();
export const Resource$isTrack = (value) => value instanceof Track;

export class Video extends $CustomType {}
export const Resource$Video = () => new Video();
export const Resource$isVideo = (value) => value instanceof Video;

export class Worker extends $CustomType {}
export const Resource$Worker = () => new Worker();
export const Resource$isWorker = (value) => value instanceof Worker;
